import React from 'react'
import { GoDotFill } from 'react-icons/go'

function PeopleSkeleton() {
    return (
        <div className="space-y-5">
            {[1, 2, 3, 4].map((index) => (
                <div key={index} className="flex items-center justify-between animate-pulse">
                    <div className="flex items-center justify-center gap-3">
                        <div className="size-20 rounded-full bg-gray-200" />
                        <div>
                            <div className="h-6 w-32 bg-gray-200 rounded" />
                            <div className="flex gap-2 items-center my-2">
                                <div className="h-4 w-16 bg-gray-200 rounded" />
                                <GoDotFill fontSize={14} className="text-gray-200" />
                                <div className="h-4 w-16 bg-gray-200 rounded" />
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                        <div className="size-6 bg-gray-200 rounded" />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default PeopleSkeleton